/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Button } from '@micromag/core/components';

import useStoryDelete from '../../hooks/useStoryDelete';

const propTypes = {
    story: MicromagPropTypes.story.isRequired,
    className: PropTypes.string,
    onComplete: PropTypes.func,
    onCancel: PropTypes.func,
};

const defaultProps = {
    className: null,
    onComplete: null,
    onCancel: null,
};

const StoryDeleteForm = ({ story, className, onComplete, onCancel }) => {
    const { id } = story || {};
    const [error, setError] = useState('');

    const { delete: deleteStory } = useStoryDelete(id);
    const postForm = useCallback(() => {
        deleteStory(id)
            .then(() => {
                if (onComplete !== null) {
                    onComplete();
                }
            })
            .catch((e) => {
                setError(e.message || 'Error');
            });
    }, [id, setError, deleteStory, onComplete]);

    return (
        <div
            className={classNames([
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className="mb-2">
                <FormattedMessage
                    defaultMessage="Are you sure you want to delete this story?"
                    description="Confirmation message"
                />
                {error ? <p className="text-danger my-1">{error}</p> : null}
            </div>
            <div className="actions">
                <Button
                    theme="primary"
                    size="md"
                    outline
                    onClick={onCancel}
                    className={classNames([
                        'me-2',
                        {
                            active: false,
                        },
                    ])}
                >
                    <FormattedMessage defaultMessage="Cancel" description="Button label" />
                </Button>
                <Button
                    theme="danger"
                    size="md"
                    outline
                    onClick={postForm}
                    className={classNames({
                        active: true,
                    })}
                >
                    <FormattedMessage defaultMessage="Delete story" description="Button label" />
                </Button>
            </div>
        </div>
    );
};

StoryDeleteForm.propTypes = propTypes;
StoryDeleteForm.defaultProps = defaultProps;

export default StoryDeleteForm;
